import dynamic from 'next/dynamic'
import PageTitle from 'components/page-title/page-title'
import Meta from 'components/meta/meta'
import useAppState from 'utils/state'

const Card = dynamic(() => import('components/card/card'))
const Infinite = dynamic(() => import('components/infinite/infinite'))

export default function Page() {
    const { loading } = useAppState()

    return (
        <>
            <Meta title="Mano norų sąrašas" description="Įsimintų prekių sąrašo puslapis." />
            <PageTitle center={1}>Mano norų sąrašas</PageTitle>
            {!loading && <Infinite endpoint="favorited-products" component={Card} />}
        </>
    )
}
